// 3rd party
import { OnInit, AfterContentInit, Component, Input, Renderer2, ElementRef, ContentChildren, EventEmitter, Output, QueryList, AfterViewInit } from '@angular/core';

// directives
import { MyDTColumnDirective } from './my-dt-column.directive';

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[my-dt]',
  template: '<ng-content></ng-content>',
  styleUrls: ['./my-dt.component.css']
})
export class MyDTComponent implements AfterContentInit, AfterViewInit {

  @ContentChildren(MyDTColumnDirective, { descendants: true }) columns: QueryList<MyDTColumnDirective>;

  @Output('onSort') onSort: EventEmitter<any> = new EventEmitter();

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngAfterContentInit() {
    this.setColumnsSort();
  }

  // Esse ciclo é responsável por observar e acionar o método setColumnsSort quando uma mudança ocorrer na quantidade de colunas filhas desse componente
  ngAfterViewInit() {
    this.columns.changes.subscribe(() => this.setColumnsSort());
  }

  // Esse método serve para retirar o ícone de ordenação das outras colunas que não estão sendo ordenadas
  setColumnsSort() {
    const lst = this.columns.toArray();
    lst.forEach(c => {
      c.onSort.subscribe(data => {
        lst.forEach(c2 => {
          if (c2.column !== c.column) {
            c2.sort(null);
          }
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/my-dt/my-dt.component.ts